export interface UsageBreakdown {
  input_tokens?: number | string | null;
  output_tokens?: number | string | null;
  cached_tokens?: number | string | null;
  cache_creation_tokens?: number | string | null;
  cache_read_tokens?: number | string | null;
  cache_write_tokens?: number | string | null;
  total_tokens?: number | string | null;
  input_cost?: number | string | null;
  output_cost?: number | string | null;
  cache_read_cost?: number | string | null;
  cache_write_cost?: number | string | null;
  prompt_cache_cost?: number | string | null;
  uncategorized_cost?: number | string | null;
  total_cost?: number | string | null;
}

export const USAGE_BREAKDOWN_KEYS: Array<keyof UsageBreakdown> = [
  'input_tokens',
  'output_tokens',
  'cached_tokens',
  'cache_creation_tokens',
  'cache_read_tokens',
  'cache_write_tokens',
  'total_tokens',
  'input_cost',
  'output_cost',
  'cache_read_cost',
  'cache_write_cost',
  'prompt_cache_cost',
  'uncategorized_cost',
  'total_cost',
];

export const toUsageNumber = (value: unknown): number => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const emptyUsageBreakdown = (): Required<Record<keyof UsageBreakdown, number>> => ({
  input_tokens: 0,
  output_tokens: 0,
  cached_tokens: 0,
  cache_creation_tokens: 0,
  cache_read_tokens: 0,
  cache_write_tokens: 0,
  total_tokens: 0,
  input_cost: 0,
  output_cost: 0,
  cache_read_cost: 0,
  cache_write_cost: 0,
  prompt_cache_cost: 0,
  uncategorized_cost: 0,
  total_cost: 0,
});

export const hasUsageBreakdown = (usage?: UsageBreakdown | null): boolean => {
  if (!usage || typeof usage !== 'object') return false;
  return USAGE_BREAKDOWN_KEYS.some((key) => toUsageNumber(usage[key]) > 0);
};

export const mergeUsageBreakdowns = (
  ...items: Array<UsageBreakdown | null | undefined>
): UsageBreakdown => {
  const merged = emptyUsageBreakdown();
  items.forEach((item) => {
    if (!item || typeof item !== 'object') return;
    USAGE_BREAKDOWN_KEYS.forEach((key) => {
      merged[key] += toUsageNumber(item[key]);
    });
  });
  return merged;
};
